import { SSE_EVENT_TYPES } from '@/utils/constants';

/**
 * SSE 消息事件数据格式。
 */
export interface SSEMessageEvent {
  type: 'chunk' | 'done' | 'error' | 'safety_alert' | 'message_saved' | 'session_title';
  model: 'left' | 'right' | 'both';
  content?: string;
  message_id?: string;
  user_message_id?: string;
  title?: string;
  brainRegion?: string;
  stage?: string;
}

/**
 * SSE 连接管理器返回的控制句柄。
 */
export interface SSEConnectionHandle {
  close: () => void;
}

/**
 * 创建 SSE 长连接，用于接收流式聊天响应。
 *
 * @param url SSE 端点完整 URL
 * @param onMessage 收到消息事件时的回调
 * @param onError 收到错误事件或连接出错时的回调
 * @param onDone 连接正常关闭时的回调
 * @returns SSEConnectionHandle 可手动调用 close() 关闭连接
 */
export function createSSEConnection(
  url: string,
  onMessage: (event: SSEMessageEvent) => void,
  onError: (error: Error) => void,
  onDone: () => void
): SSEConnectionHandle {
  const eventSource = new EventSource(url);

  eventSource.onmessage = (event: MessageEvent) => {
    try {
      const data: SSEMessageEvent = JSON.parse(event.data);
      onMessage(data);
      if (data.type === SSE_EVENT_TYPES.DONE || data.type === SSE_EVENT_TYPES.ERROR) {
        eventSource.close();
        onDone();
      }
    } catch (err) {
      onError(new Error(`解析 SSE 消息失败: ${String(err)}`));
      eventSource.close();
      onDone();
    }
  };

  eventSource.onerror = () => {
    onError(new Error('SSE 连接发生错误'));
    eventSource.close();
    onDone();
  };

  return {
    close: () => {
      eventSource.close();
      onDone();
    },
  };
}
